import { render, staticRenderFns } from "./setpRank.vue?vue&type=template&id=87182b4a&scoped=true"
import script from "./setpRank.vue?vue&type=script&lang=js"
export * from "./setpRank.vue?vue&type=script&lang=js"
import style0 from "./setpRank.vue?vue&type=style&index=0&id=87182b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87182b4a",
  null
  
)

export default component.exports